module.exports = __webpack_public_path__ + "../resources/img/ic_module_pattern_landscape.4c24a300.svg";